<div class="box">
  <router-outlet></router-outlet>
</div>
